export function getdata() {
	var obj = {
		headDataI: [{
				title: "操作",
				prop: "cz",
				width: "150px",
				custom: true,
			}, {
				title: "应税消费品名称",
				prop: "xfs_0_x_0.1",
				width: "150px",
				custom: true,
			},
			{
				title: "适用税率",
				children: [{
					custom: true,
					prop: "xfs_0_x_1",
					title: "定额税率",
				}, {
					custom: true,
					prop: "xfs_0_x_2",
					title: "比例税率",
				}]
			},
			{
				title: '计量单位',
				prop: 'xfs_0_x_3',
				width: "150px",
				custom: true,
			}, {
				title: "销售数量",
				children: [{
					custom: true,
					prop: "xfs_0_x_4",
					title: "本期数",
				}, {
					custom: true,
					prop: "xfs_0_x_4A",
					title: "本年累计",
				}]
			}, {
				title: "销售额",
				children: [{
					custom: true,
					prop: "xfs_0_x_5",
					title: "本期数",
				}, {
					custom: true,
					prop: "xfs_0_x_5B",
					title: "本年累计",
				}]
			}, {
				title: "应纳税额",
				children: [{
					custom: true,
					prop: "xfs_0_x_6",
					title: "本期数",
				}, {
					custom: true,
					prop: "xfs_0_x_6C",
					title: "本年累计",
				}]
			},
		],

		tableDataI: [{
				xfs_0_x_0: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_4A: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_5B: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_6C: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				}
			}, {
				disablednoty_xfs_0_x_1: false,
				disablednoty_xfs_0_x_2: false,
				disablednoty_xfs_0_x_3: false,
				disablednoty_xfs_0_x_4: false,
				disablednoty_xfs_0_x_4A: false,
				disablednoty_xfs_0_x_5: false,
				disablednoty_xfs_0_x_5B: false,
				disablednoty_xfs_0_x_6: false,
				disablednoty_xfs_0_x_6C: false,
				xfs_0_x_0: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_4A: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_5B: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_6C: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				}
			}, {
				disablednoty_xfs_0_x_1: false,
				disablednoty_xfs_0_x_2: false,
				disablednoty_xfs_0_x_3: false,
				disablednoty_xfs_0_x_4: false,
				disablednoty_xfs_0_x_4A: false,
				disablednoty_xfs_0_x_5: false,
				disablednoty_xfs_0_x_5B: false,
				disablednoty_xfs_0_x_6: false,
				disablednoty_xfs_0_x_6C: false,
				xfs_0_x_0: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_1: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_2: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_3: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_4: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_4A: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_5: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_5B: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_6: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				},
				xfs_0_x_6C: {
					cellCode: "ty_0_x_1",
					cellType: "1",
					cellVal: "0.00"
				}
			},

		],
		headDataII: [{
				prop: "tes1",
				title: "",
			},
			{
				prop: "grade",
				title: "栏次",
			},
			{
				custom: true,
				prop: "xfs_0_x_1",
				title: "本期数",
			},
			{
				custom: true,
				prop: "xfs_0_x_1D",
				title: "本年累计D",
			}
		],
		tableDataII: [{
			tes1: "本期减（免）税额",
			grade: "7",
			hanh: "1001",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "1122"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "3322"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, {
			tes1: "期初留底税额",
			grade: "8",
			hanh: "1002",
			xfs_0_x_1: {
				cellCode: "xfs_0_1002_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1002_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: true,
		}, {
			tes1: "本期准予扣除税额",
			grade: "9",
			hanh: "1003",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, {

			tes1: "本期应扣除税额",
			grade: "10=8+9",
			hanh: "1004",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: true,
		}, {

			tes1: "本期实际扣除税额",
			grade: "11[10<(6-7), 则为10,否则为6-7]",
			hanh: "1005",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, {

			tes1: "期末留底税额",
			grade: "12=10-11",
			hanh: "1006",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: true,
		}, {
			tes1: "本期预缴税额",
			grade: "13",
			hanh: "1007",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: false,
			disablednoty_0_x_tes4: true,
		}, {

			tes1: "本期应补（退）税额",
			grade: "14=6-7-11-13",
			hanh: "1008",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, {
			tes1: "城市维护建设税本期应补（退）税额",
			grade: "15",
			hanh: "1009",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, {
			tes1: "教育费附加本期应补（退）税额",
			grade: "16",
			hanh: "1010",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, {
			tes1: "地方教育费附加本期应补（退）税额",
			grade: "17",
			hanh: "1011",
			xfs_0_x_1: {
				cellCode: "xfs_0_1001_1",
				cellType: "1",
				cellVal: "0.00"
			},
			xfs_0_x_1D: {
				cellCode: "xfs_0_1001_1D",
				cellType: "1",
				cellVal: "0.00"
			},
			disablednoty_0_x_tes3: true,
			disablednoty_0_x_tes4: false,
		}, ]
	}
	return obj
}